export function useHeadService() {
  const setMeta = (title,description,ogImageTemplate,ogImageData) => {
    if(!ogImageTemplate){
      ogImageTemplate = 'Default';
    }
    if(!ogImageData){
      ogImageData = {};
    }
    const route = useRoute();
    useHead({
      htmlAttrs: {
        lang: 'en'
      },
      title: title,
      meta: [
        {name: 'description', content: description},
      ],
      link: [
        {
          rel: 'icon',
          type: 'image/png',
          href: '/favicon/favicon-96x96.png'
        },
        {
          rel: 'canonical',
          href: `https://tapleagues.com${route.path}`, // Adjust the domain as needed
        },
      ]
    });
    defineOgImageComponent(ogImageTemplate, {
      leadingTitle : 'Tap Leagues',
      title: title,
      ...ogImageData
    })
  };
  return {
    setMeta
  };
}

